import { ServiceConfig } from 'lib/api/helpers/requestConfigUtils';

export const NO_REDIRECT_SERVICE_METHODS: ServiceConfig[] = [
  { service: 'Event', methods: ['*'] },
  { service: 'SessionProgress', methods: ['book_next_session'] },
  { service: 'ProductStreamVersion', methods: ['get_latest_version'] },
  { service: 'UserAccount', methods: ['get_user_info'] },
];
